module.exports = __webpack_public_path__ + "static/media/case-management.e2ccfab9.svg";